var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRokuTvCircled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.895 58.2476C28.895 54.8394 26.1531 52.0947 22.8003 52.0947H19.7779V64.346H22.8003C26.1531 64.346 28.895 61.5994 28.895 58.2476ZM42.6437 82.6708H31.5488L22.7404 70.447H19.7779V82.6444H10V46H24.0074C32.0825 46 38.6737 51.4913 38.6737 58.2476C38.6737 62.3681 36.1468 66.0485 32.3013 68.3005L42.6437 82.6708",
    fill: "#2D2F35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6715 60.4478C51.0893 60.4478 48.8928 63.9577 48.8928 68.3025C48.8928 72.6472 51.0893 76.1616 53.6715 76.1616C56.3136 76.1616 58.5064 72.6471 58.5064 68.3025C58.5064 63.9576 56.3136 60.4478 53.6715 60.4478M68.7217 68.3025C68.7217 76.6026 61.9718 83.2492 53.6715 83.2492C45.3739 83.2492 38.6738 76.6026 38.6738 68.3025C38.6738 60.0085 45.3739 53.3584 53.6715 53.3584C61.9718 53.3584 68.7217 60.0085 68.7217 68.3025M91.6674 53.9662L80.4037 65.228V53.9289H70.6278V82.6455H80.4037V70.9969L92.163 82.6455H104.468L89.5245 67.7003L101.902 55.3276V72.3692C101.902 78.0273 105.304 83.2489 113.873 83.2489C117.941 83.2489 121.674 80.9418 123.489 78.8542L127.884 82.6454H129.971V53.9662H120.195V72.5345C119.094 74.4559 117.56 75.664 115.189 75.664C112.784 75.664 111.68 74.2381 111.68 69.6771V53.9662H91.6674Z",
    fill: "#2D2F35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 69.5,
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRokuTvCircled);
export default __webpack_public_path__ + "static/media/roku-tv-circled.b5712866f0ee9d5d8ee4e46abadd36d7.svg";
export { ForwardRef as ReactComponent };